<div class="overlay" [class.visible]="isVisible" (click)="closeSidebar(false)"></div>
<div class="sidebar" [class.visible]="isVisible" >
   <div class="order-container">
      <div>
      <header>
         <div class="back-button">
            <i (click)="closeSidebar(false)" class="material-icons back-icon">arrow_back</i>
            <div class="title">My Request Wishlist</div>
         </div>
      </header>
      <div class="spares-card">
        <div class="logo">
          <img src="{{vehicleData.imageUrlPath}}" alt="Logo" />
        </div>
        <div class="details">
          <p><strong>{{vehicleData.model}}, {{vehicleData.fuel}}</strong></p>
          <p>{{vehicleData.variant}}, [{{vehicleData.year}}]</p>
          <p>{{vehicleData.registrationNumber}}</p>
        </div>
      </div>
         </div>
        </div>
        <div *ngIf="wishlistItems?.length>0">
            <p class="requested">Request Wishlist</p>
            <div class="wishlist-list-wrapper">
            <div *ngFor="let item of wishlistItems">
            <div class="added">
              <div>
                <div class="item-title">{{ getSuggestionName(item.name) | titlecase }}</div>
                <div class="item-subtitle">{{ item.name | titlecase }}</div>
              </div>

                <div class="wishlist-quantity">
                    <mat-icon (click)="decreaseQty(item)">remove</mat-icon>
                    <span class="qty-value">{{ getItemQuantity(item.name) || 1 }}</span>
                    <mat-icon (click)="increaseQty(item)">add</mat-icon>
                </div>
                </div>
            </div>
            </div>
            <div class="request" (click)="createRequest()">
                <div class="place">
                    Place Request
                </div>
            </div>
        </div>
        <div *ngIf="wishlistItems?.length<=0" class="no-match">
            <div class="empty-item">
                <img class="empty-img" src="{{emptyImg}}" alt="" />
                <div class="sec1">No spares added yet!</div>
                <div class="sec2">Your request wishlist is empty</div>
                <div class="sec2">Your car parts are just a click away</div>
                <button class="back" (click)="closeSidebar(false)">Go Back</button>
            </div>
        </div>
</div>
<div class="popup" *ngIf="isPopupOpen">
    <div class="popup-content order-success-sec">
      <img src="{{ successIcon }}" alt="Success Icon">
      <mat-icon class="close-popup" (click)="closePopup()">close</mat-icon>

      <h3>Request Created!</h3>
      <p class="order-label"><span class="order-id">Request ID  {{requestId}}</span></p>
      <p class="date"><span>{{requestCreated | date:'dd MMM yyyy, hh:mm a'}}</span></p>
      <p class="thank-you">Let us deliver an awesome experience!</p>
      <button class="goto-order" (click)="requestPage()">Track My Request </button>
    </div>
  </div>